export const kredittbankenTrackingIDs = {
    applyForConsumerLoan: 'kredittbank-kredittbanken-web__apply-for-consumer-loan',
    applyForRefinancing: 'kredittbank-kredittbanken-web__apply-for-refinancing',
    loanOverviewActions: 'kredittbank-kredittbanken-web__loan-overview-action',
    repaymentPlan: 'kredittbank-kredittbanken-web__repayment-plan',
};
